// extracted by mini-css-extract-plugin
export default {"frenchTitle":"styles_frenchTitle__ODGSW","errorWrapper":"styles_errorWrapper__P4+0B"};